import uiCore = require("../../core/uicore");
import dataCore = require("../../core/datacore");
import entityCache = require("../../core/entitycache");
import entityHelper = require("../../core/entityhelper");

export interface IPersonWorkplaceStateParams {
    personWorkplaceId: number;
    personId: number;
}

export class PersonWorkplaceStateStrings {
    public static List = "resources.persons.detail";
    public static Details = "resourcespersonsworkplacetitlesdetails";
    public static New = "resourcespersonsworkplacetitlesnew";
    public static Edit = "resourcespersonsworkplacetitlesdetailsedit";
}

class PersonWorkplaceBase  implements uiCore.IDirective {

    public personWorkplace: Nema.Crew.Model.PersonWorkplace;
    protected dataCache: entityCache.EntityCache;
    private _locator: uiCore.DependencyLocator;
    private _changesResolved: boolean;
    private _isNew: boolean;
    private _state: IPersonWorkplaceStateParams;

    public static BaseAngularDependencies: uiCore.IAngularDependencyId[] = [uiCore.ScopeDependency, uiCore.StateParamsDependency, uiCore.StateDependency, uiCore.MdDialogDependency];

    constructor(isNew: boolean, onDataLoaded: () => void, component: uiCore.IComponentWithDescription, injected: any[]) {
        this._changesResolved = false;
        this._isNew = isNew;
        this._locator = uiCore.DependencyLocator.Create(component, injected);
        this._state = <IPersonWorkplaceStateParams><any>this._locator.getStateParamsDependency();
        this.dataCache = new entityCache.EntityCache(entityCache.CommonEntityManagers.EntityManager);
        var dataDependencies: string[] = [
            entityCache.EntityTypeNames.Person,
            entityCache.EntityTypeNames.Workplace,
            entityCache.EntityTypeNames.PersonWorkplace,
        ];
        var entitiesPromise = this.dataCache.getEntitySetsPromise(dataDependencies);
        var self = this;

        entitiesPromise.then(res => {
            this.initializedata(isNew, res);
            if (onDataLoaded) {
                onDataLoaded();
            }
            self._locator.getScopeDependency().$apply();
        }).catch(_reason => {
        });
    }

    protected initializedata(isNew: boolean, _res: entityCache.EntitySetDictionary) {
        if (isNew) {
            var person = <any>this.dataCache.getEntity(entityCache.EntityTypeNames.Person, this._state.personId);
            if (!person) return;
            var newPersonWorkplace = <Nema.Crew.Model.PersonWorkplace> { Person: person, FromDate: dataCore.getToday() };
            this.personWorkplace = <any>this.dataCache.entityManager.createEntity(entityCache.EntityTypeNames.PersonWorkplace, newPersonWorkplace);
        }
        else {
            this.personWorkplace = <any>this.dataCache.getEntity(entityCache.EntityTypeNames.PersonWorkplace, this._state.personWorkplaceId);
        }
    }

    public querySearchWorkplace(searchString: string): Nema.Crew.Model.Workplace[] {
        return <any[]> this.dataCache.searchActiveByName(entityCache.EntityTypeNames.Workplace, searchString);
    }

    public delete() {

        var listOfChanges = [
            () => { (<breeze.Entity><any>this.personWorkplace).entityAspect.setDeleted(); }
        ];

        // TODO: Why this?
        this.personWorkplace.Person;

        entityHelper
            .confirmedSaveSequentialListOfChangesAndNavigate(
            listOfChanges,
            "Delete Person Workplace",
            "Please confirm to delete Person Workplace",
            this.dataCache.entityManager,
            this._locator.getMdDialogDependency(),
            () => { this.goToList() },
            this._locator.getStateDependency());
    }

    public edit() {
        this._locator.getStateDependency().go("app." + PersonWorkplaceStateStrings.Edit, <IPersonWorkplaceStateParams>{ personWorkplaceId:this.personWorkplace.Id });
    }

    public cancel() {
        this._changesResolved = true;
        this.dataCache.entityManager.rejectChanges();
        if (this._isNew) {
            this.goToList();
        }
        else {
            this.goToDetails();
        }
    }

    protected goToList = () => {
        this._locator
            .getStateDependency()
            .go("app." + PersonWorkplaceStateStrings.List, { personId: this.personWorkplace.PersonId });
    }

    protected goToDetails = () => {
        this._locator.getStateDependency().go("app." + PersonWorkplaceStateStrings.Details, <IPersonWorkplaceStateParams> { personWorkplaceId: this.personWorkplace.Id });
    }

    //private goToNew() {
    //    this._locator
    //        .getStateDependency()
    //        .go("app." + PersonWorkplaceStateStrings.New, <IPersonWorkplaceStateParams> { personId: this._state.personId });
    //}

    public save() {
        var listOfChanges = [
            () => { },
        ];
        this._changesResolved = true;
        entityHelper.saveSequentialListOfChangesAndNavigate(listOfChanges, this.dataCache.entityManager, this.goToDetails, this._locator.getStateDependency());
    }

    public hasChanges() {
        if (this._changesResolved) return false;
        if (this._isNew) return true;
        if (this.dataCache.entityManager.hasChanges()) return true;
        return false;
    }
}

export class PersonWorkplaceDetails extends PersonWorkplaceBase {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: PersonWorkplaceStateStrings.Details,
        Url: "/resources/personworkplace/{personWorkplaceId:int}",
        HeaderText: "Resources &raquo; Persons &raquo; Workplaces",
        StateString: PersonWorkplaceStateStrings.Details,
        Template: require("./personworkplace.details.html"),
        AngularDependencies: PersonWorkplaceBase.BaseAngularDependencies
    }

    constructor(...args: any[]) {
        super(false,() => {
        }, PersonWorkplaceDetails, args);
    }
}

export class PersonWorkplaceEdit extends PersonWorkplaceBase {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: PersonWorkplaceStateStrings.Edit,
        Url: "/resources/personworkplace/edit/{personWorkplaceId:int}",
        HeaderText: "Resources &raquo; Persons &raquo; Workplaces",
        StateString: PersonWorkplaceStateStrings.Edit,
        Template: require("./personworkplace.edit.html"),
        AngularDependencies: PersonWorkplaceBase.BaseAngularDependencies
    }

    constructor(...args: any[]) {
        super(false,() => {
        }, PersonWorkplaceDetails, args);
    }
}

export class PersonWorkplaceNew extends PersonWorkplaceBase {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: PersonWorkplaceStateStrings.New,
        Url: "/resources/personworkplace/new/{personId:int}",
        HeaderText: "Resources &raquo; Persons &raquo; Workplaces",
        StateString: PersonWorkplaceStateStrings.New,
        Template: require("./personworkplace.new.html"),
        AngularDependencies: PersonWorkplaceBase.BaseAngularDependencies
    }

    constructor(...args: any[]) {
        super(true,() => {
        }, PersonWorkplaceDetails, args);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/personworkplace/personworkplace.common.ts